import { render, staticRenderFns } from "./RadioJN.vue?vue&type=template&id=4b8782ab&scoped=true&"
import script from "./RadioJN.vue?vue&type=script&lang=js&"
export * from "./RadioJN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8782ab",
  null
  
)

export default component.exports